/**
 * Contains Async Actions
 */
import pick from "lodash/pick";
import { jsonDataFormatter } from "@stadium/helpers/formatter";
import { configActions } from "@stadium/redux-utils/slices";

import { SM_PROGRAM_ID, SM_PROGRAM_IDENTIFIER } from "@constants/app-defaults";

import { axiosInstance } from "@services/axios";
import { getCountriesWithInternationalData } from "@helpers/currency";

const emptyObj = {};

const whiteListedConfigParams = ["countries", "currencies", "currencyConversionRates"];
export const fetchConfig = () => async (dispatch) => {
  axiosInstance
    .get("config", {
      program_id: SM_PROGRAM_ID,
    })
    .then((res) => {
      const formattedResponse = jsonDataFormatter(JSON.parse(res));
      const unformattedConfigData = formattedResponse?.config?.configId || emptyObj;
      const spreeTaxons = formattedResponse?.spreeTaxons;
      const configData = {
        ...getCountriesWithInternationalData(pick(unformattedConfigData, whiteListedConfigParams)),
        activeProgramDetail: unformattedConfigData.activeProgramDetails[SM_PROGRAM_IDENTIFIER],
        spreeTaxons,
      };
      dispatch(configActions.updateAttributes(configData));
      dispatch(configActions.isFetchingConfig(false));
    })
    .catch((error) => {
      throw error;
    });
};
